import {
  FeatureName,
  useAssetListFilter,
  useIsFeatureEnabled,
  useSetAssetListFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet } from 'react-native';
import { colors as CropCircleColors } from '../crop-circle/tokens';
import { DebouncedTextInput } from '../forms';

export const AssetSearchInput = ({ onBlur }: { onBlur?: () => void } = {}) => {
  const isCropCircleRedesign = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const { t } = useTranslation();
  const { data: assetFilter, isLoading } = useAssetListFilter();
  const { mutateAsync } = useSetAssetListFilter();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && assetFilter?.keyword) {
      setText(assetFilter.keyword);
    }
  }, [assetFilter]);

  const updateSearch = async (keyword: string) => {
    assetFilter.keyword = keyword;
    await mutateAsync(assetFilter);
  };

  return (
    assetFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={updateSearch}
        placeholder={t('assets.filter.searchPlaceholder')}
        value={text}
        onBlur={() => { if (!text && onBlur) onBlur(); }}
        onChangeText={(text) => setText(text)}
        height={isCropCircleRedesign ? 32 : 44}
        width={'100%'}
        outlineStyle={{
          ...styles.inputStyle,
          backgroundColor:
            isCropCircleRedesign || Platform.OS !== 'web'
              ? CropCircleColors.neutral[200]
              : 'white',
        }}
        disableInnerStyle={true}
        autoFocus={!isLoading && !assetFilter?.keyword}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: CropCircleColors.neutral[200],
    borderWidth: 0,
    borderRadius: 8,
  },
});
